export const contactTypeClassMap = {
  supplier: '!bg-supplier',
  sponsor: '!bg-sponsor',
  partner: '!bg-partner',
  events: '!bg-events',
}
